import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import {CookieService} from 'ngx-cookie';
declare var DDP_ENV: any;
@Injectable({
  providedIn: 'root'
})
export class EventLogService {
  readonly baseURL = DDP_ENV.webdataUrl;

  constructor(private _http: Http, private cookieService: CookieService) {}

  getAllEventLogs(campaignId, clientId, status, regExp, page, size) {
    if (campaignId === undefined) {
      return this._http.get(this.baseURL + '/eventlogs/' + clientId + '?status='+status+'&regexPattern='+regExp+'&page=' + page + '&size=' + size, this.buildHeaders());
    } else {
      // tslint:disable-next-line:max-line-length
      return this._http.get(this.baseURL + '/eventlogs/' + clientId + '/campaign/' + campaignId + '?status='+status+'&regexPattern='+regExp+'&page=' + page + '&size=' + size, this.buildHeaders());
    }
  }

 /* Construct a common header */
  private buildHeaders(): any {
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers });
  }

}
